An opaque cursor to the later bounding advertisement brandings.

Resulting advertisement brandings will _precede_ this cursor.
